import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLremoveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.43 2.56H16.01C15.28 1.01 13.73 0 12 0C10.27 0 8.72002 1.02 7.99002 2.56H4.57002C3.34002 2.56 2.33002 3.56 2.33002 4.8V7.28C2.33002 8 2.81002 8.61 3.46002 8.81L4.60002 22.5C4.67002 23.34 5.38002 24 6.23002 24H17.77C18.61 24 19.33 23.34 19.4 22.5L20.54 8.81C21.19 8.6 21.67 8 21.67 7.27V4.79C21.67 3.56 20.67 2.55 19.43 2.55V2.56ZM12 2C12.57 2 13.11 2.21 13.54 2.56H10.46C10.89 2.21 11.43 2 12 2ZM4.33002 4.8C4.33002 4.67 4.44002 4.56 4.57002 4.56H19.43C19.56 4.56 19.67 4.67 19.67 4.8V6.9H4.33002V4.8ZM17.43 22H6.57002L5.48002 8.89H18.53L17.44 22H17.43Z"
        fill={color}
      />
      <path
        d="M12 10.47C11.45 10.47 11 10.92 11 11.47V19.27C11 19.82 11.45 20.27 12 20.27C12.55 20.27 13 19.82 13 19.27V11.47C13 10.92 12.55 10.47 12 10.47Z"
        fill={color}
      />
      <path
        d="M8.02003 10.47C7.47003 10.52 7.06002 11 7.11002 11.55L7.76003 19.35C7.80003 19.87 8.24003 20.27 8.76003 20.27C8.79002 20.27 8.82002 20.27 8.84002 20.27C9.39002 20.23 9.80002 19.74 9.75002 19.19L9.10003 11.39C9.05003 10.84 8.57003 10.43 8.02003 10.48V10.47Z"
        fill={color}
      />
      <path
        d="M15.98 10.47C15.42 10.42 14.95 10.83 14.9 11.38L14.25 19.18C14.2 19.73 14.61 20.21 15.16 20.26C15.19 20.26 15.22 20.26 15.24 20.26C15.75 20.26 16.19 19.87 16.24 19.34L16.89 11.54C16.94 10.99 16.53 10.51 15.98 10.46V10.47Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLremoveIcon.displayName = 'HierLremoveIcon';
